module.exports = __webpack_public_path__ + "img/broom_in_package.b11b6426.jpg";